import * as React from 'react';
import { FormField } from 'react-mvvm/forms';
import { MembershipApplicationRequirement } from 'model/Externals';
import AntField from 'common/components/antHelpers/AntField';
import { useTranslation } from 'react-i18next';
import AntCheckbox from '../AntCheckbox';

interface MembershipRequirementFieldProps {
    field: FormField<MembershipApplicationRequirement | undefined>;
}
const GraduateMembershipRequirementField: React.FC<MembershipRequirementFieldProps> = ({
    field
}) => {
    const { t } = useTranslation('membership');
    return (
        <AntField
            field={field}
            label={t('membershipApplicationRequirementLabel')}
            description={t('membershipApplicationRequirementDescription')}>
            {(props) => (
                <AntCheckbox
                    content={t('graduateSchoolEducationRequirement')}
                    onChange={(e) => props.onChange(e.valueOf() ? MembershipApplicationRequirement.graduateEducation : undefined)}
                    value={field.value === MembershipApplicationRequirement.graduateEducation}
                />
            )}
        </AntField>
    );
};

export default GraduateMembershipRequirementField;
